import React, { Suspense, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { motion } from "framer-motion";

const AddOns = React.lazy(() => import("./AddOns.jsx"));

export default function AddOnsPortal() {
  const [mounted, setMounted] = useState(false);
  const [target, setTarget] = useState(null);

  useEffect(() => {
    const el = document.getElementById("addons-root");
    if (el) {
      setTarget(el);
      setMounted(true);
    }
  }, []);

  if (!mounted || !target) return null;

  return createPortal(
    <Suspense fallback={null}>
      <div className="w-full px-4 sm:px-10 py-20 bg-white">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-7xl mx-auto"
        >
          <AddOns />
        </motion.div>
      </div>
    </Suspense>,
    target
  );
}
